import { useTranslation } from '@framework/i18n';
import { ErrorResultA11y } from './ErrorResultA11y';
import { IErrorResultBodyProps } from './ErrorResultBody';
import { OnPageResultContainer } from './OnPageResultContainer';

/**
 * Props condivise tra i componenti di errore.
 */
export function NotFoundBody(props: IErrorResultBodyProps) {
  const { message, description, title } = props;
  const { t } = useTranslation();

  return (
    <OnPageResultContainer>
      <ErrorResultA11y
        status="error"
        title={title ?? t('alert.not-found-body.title', '404 Non Trovato')}
        subTitle={
          message ?? t('alert.not-found-body.subtitle', 'Pagina Non Trovata.')
        }
        extra={description}
      />
    </OnPageResultContainer>
  );
}
